import Vue from 'vue'
import Router from 'vue-router'
import axios from 'axios'
import store from '@/store'
import diseaseManageDetail from '@/views/order/diseaseManageDetail'

Vue.use(Router)
Vue.prototype.axios = axios
const routerPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return routerPush.call(this, location).catch(error => error)
}
const router = new Router({
  mode: 'history',
  scrollBehavior (to, from, savedPosition) {
    if (to.name === 'epidemicActivity' && savedPosition) {
      return savedPosition
    } else {
      return { y: 0 }
    }
  },
  base: '/syrjiaPatientEnd/', // 本地需注释
  routes: [{
    path: '/',
    redirect: '/hospitalIndex'
  },
  {
    path: '/be_careful',
    name: 'be_careful',
    component: resolve => require(['@/views/im/be_careful'], resolve),
    meta: {
      title: '服药禁忌'
    }
  },
  {
    path: '/offineStatistics',
    name: 'offineStatistics',
    component: resolve => require(['@/views/statistics/index'], resolve),
    meta: {
      title: '医馆费用统计'
    }
  },
  { // 名医名方
    path: '/im_prescription',
    name: 'im_prescription',
    component: resolve => require(['@/views/prescription/imConfirm'], resolve),
    meta: {
      title: '问诊'
    }
  },
  // 病程管理费服务包详情
  {
    path: '/diseaseManageDetail',
    name: 'diseaseManageDetail',
    component: diseaseManageDetail,
    meta: {
      title: '诊后病程管理'
    }
  },
  { // 名医名方
    path: '/prescription-list',
    name: 'prescriptionList',
    component: resolve => require(['@/views/prescription/prescriptionList'], resolve),
    meta: {
      title: '名医名方'
    }
  },
  {
    path: '/epidemicActivity',
    name: 'epidemicActivity',
    component: resolve => require(['@/views/activity/epidemicActivity'], resolve),
    meta: {
      title: '全民抗疫',
      keepAlive: true
    }
  },
  {
    path: '/epidemicNewsDetail',
    name: 'epidemicNewsDetail',
    component: resolve => require(['@/views/activity/epidemicNewsDetail'], resolve),
    meta: {
      title: '防疫资讯'
    }
  },
  {
    path: '/pay',
    name: 'pay',
    component: resolve => require(['@/views/pay/pay'], resolve),
    meta: {
      title: '支付'
    }
  },
  {
    path: '/helpPay',
    name: 'helpPay',
    component: resolve => require(['@/views/pay/helpPay'], resolve),
    meta: {
      title: '支付'
    }
  },
  {
    path: '/pay_hint',
    name: 'pay_hint',
    component: resolve => require(['@/views/pay/pay_hint'], resolve),
    meta: {
      title: '支付宝支付'
    }
  },
  {
    path: '/pay_h5',
    name: 'pay_h5',
    component: resolve => require(['@/views/pay/pay_H5'], resolve),
    meta: {
      title: '微信支付'
    }
  },
  {
    path: '/pasteFormula',
    name: 'pasteFormula',
    component: resolve => require(['@/views/hospital/pasteFormula'], resolve),
    meta: {
      title: '膏方说明'
    }
  },
  {
    path: '/evaluate_doctor',
    name: 'evaluate_doctor',
    component: resolve => require(['@/views/hospital/evaluate_doctor'], resolve),
    meta: {
      title: '评价'
    }
  },
  {
    path: '/suremsgorder',
    name: 'suremsgorder',
    component: resolve => require(['@/views/hospital/suremsgorder'], resolve),
    meta: {
      title: '购买心意'
    }
  },
  {
    path: '/evasuccess',
    name: 'evasuccess',
    component: resolve => require(['@/views/hospital/evasuccess'], resolve),
    meta: {
      title: '评价成功'
    }
  },
  {
    path: '/now_inquiry',
    name: 'now_inquiry',
    component: resolve => require(['@/views/hospital/now_inquiry'], resolve),
    meta: {
      title: '当前问诊'
    }
  },
  // ----------------------------------  end --------------------------------
  {
    path: '/people_choose',
    name: 'peopleChoose',
    component: resolve => require(['@/views/people/people_choose'], resolve),
    meta: {
      title: '选择就诊人'
    }
  },
  {
    path: '/people_choose_referral',
    name: 'peopleChooseReferral',
    component: resolve => require(['@/views/people/people_choose_referral'], resolve),
    meta: {
      title: '选择就诊人'
    }
  },
  {
    path: '/people_info_channel',
    name: 'peopleInfoChannel',
    component: resolve => require(['@/views/people/people_info_channel'], resolve),
    meta: {
      title: '上医互联网医院'
    }
  },
  {
    path: '/people_info_channel2',
    name: 'peopleInfoChannel2',
    component: resolve => require(['@/views/people/people_info_channel2'], resolve),
    meta: {
      title: '上医互联网医院'
    }
  },
  {
    path: '/people_info',
    name: 'peopleInfo',
    component: resolve => require(['@/views/people/people_info'], resolve),
    meta: {
      title: '基础信息'
    }
  },
  {
    path: '/people_medical_info',
    name: 'peopleMedicalInfo',
    component: resolve => require(['@/views/people/people_medical_info'], resolve),
    meta: {
      title: '完善信息'
    }
  },
  {
    path: '/referral',
    name: 'referral',
    component: resolve => require(['@/views/referral/referral'], resolve),
    meta: {
      title: '复诊'
    }
  },
  {
    path: '/attention_doctor',
    name: 'attentionDoctor',
    component: resolve => require(['@/views/referral/attention_doctor'], resolve),
    meta: {
      title: '关注医生'
    }
  }, {
    path: '/doctorindex',
    name: 'doctorindex',
    component: resolve => require(['@/views/doctor/doctorIndex'], resolve),
    meta: {
      title: '医生主页'
    }
  }, {
    path: '/docabstrict',
    name: 'docabstrict',
    component: resolve => require(['@/views/doctor/docAbstrict'], resolve),
    meta: {
      title: '医生主页'
    }
  },
  {
    path: '/center_index',
    name: 'centerIndex',
     component: resolve => require(['@/views/myCenter/index.vue'], resolve),
   /* component: resolve => require(['@/views/myCenter/center_index'], resolve), */
    meta: {
      title: '个人中心'
    }
  },
  {
    path: '/center_indexNew',
    name: 'myCenterIndex',
    component: resolve => require(['@/views/myCenter/index.vue'], resolve),
    meta: {
      title: '个人中心'
    }
  },
  {
    path: '/myCaseHistory',
    name: 'myCaseHistory',
    component: resolve => require(['@/views/myCenter/myCaseHistory'], resolve),
    meta: {
      title: '病历信息'
    }
  },
  {
    path: '/updateCaseHistory',
    name: 'updateCaseHistory',
    component: resolve => require(['@/views/updateCaseMsg/updateCaseHistory'], resolve),
    meta: {
      title: '更新病历信息'
    }
  },
  {
    path: '/collection',
    name: 'collection',
    component: resolve => require(['@/views/myCenter/collection'], resolve),
    meta: {
      title: '关注收藏'
    }
  },  {
    path: '/buyServiceChannel',
    name: 'buyServiceChannel',
    component: resolve => require(['@/views/doctor/buyService_channel'], resolve),
    meta: {
      title: '购买服务'
    }
  },{
    path: '/buyService',
    name: 'buyService',
    component: resolve => require(['@/views/doctor/buyService'], resolve),
    meta: {
      title: '购买服务'
    }
  }, {
    path: '/symptomDescription',
    name: 'symptomDescription',
    component: resolve => require(['@/views/doctor/symptomDescription'], resolve),
    meta: {
      title: '症状描述'
    }
  }, {
    path: '/sendHeart',
    name: 'sendHeart',
    component: resolve => require(['@/views/doctor/sendHeart'], resolve),
    meta: {
      title: '送心意'
    }
  }, {
    path: '/paySuccess',
    name: 'paySuccess',
    component: resolve => require(['@/views/doctor/paySuccess'], resolve),
    meta: {
      title: '支付成功'
    }
  }, {
    path: '/paySuccessChannel',
    name: 'paySuccessChannel',
    component: resolve => require(['@/views/pay/paySuccessChannel'], resolve),
    meta: {
      title: '支付成功'
    }
  }, {
    path: '/aboutus',
    name: 'aboutus',
    component: resolve => require(['@/views/myCenter/aboutus'], resolve),
    meta: {
      title: '关于我们'
    }
  }, {
    path: '/agreement',
    name: 'agreement',
    component: resolve => require(['@/views/myCenter/agree'], resolve),
    meta: {
      title: '用户注册协议'
    }
  },
  {
    path: '/people_list',
    name: 'peopleList',
    component: resolve => require(['@/views/people/people_list'], resolve),
    meta: {
      title: '就诊人管理'
    }
  }, {
    path: '/chooseAddress',
    name: 'chooseAddress',
    component: resolve => require(['@/views/address/chooseAddress'], resolve),
    meta: {
      title: '选择收货地址'
    }
  }, {
    path: '/modifyAddress',
    name: 'modifyAddress',
    component: resolve => require(['@/views/address/modifyAddress'], resolve),
    meta: {
      title: '修改收货地址'
    }
  }, {
    path: '/addAddress',
    name: 'addAddress',
    component: resolve => require(['@/views/address/addAddress'], resolve),
    meta: {
      title: '添加收货地址'
    }
  },{
    path: '/chooseAddressChannel',
    name: 'chooseAddressChannel',
    component: resolve => require(['@/views/address/chooseAddressChannel'], resolve),
    meta: {
      title: '选择收货地址'
    }
  }, {
    path: '/modifyAddressChannel',
    name: 'modifyAddressChannel',
    component: resolve => require(['@/views/address/modifyAddressChannel'], resolve),
    meta: {
      title: '修改收货地址'
    }
  }, {
    path: '/addAddressChannel',
    name: 'addAddressChannel',
    component: resolve => require(['@/views/address/addAddressChannel'], resolve),
    meta: {
      title: '添加收货地址'
    }
  }, {
    path: '/orderIndex',
    name: 'orderIndex',
    component: resolve => require(['@/views/order/orderIndex'], resolve),
    meta: {
      title: '订单列表'
    }
  }, {
    path: '/orderDetail',
    name: 'orderDetail',
    component: resolve => require(['@/views/order/orderDetail'], resolve),
    meta: {
      title: '订单详情'
    }
  },
  {
    path: '/orderDetailChannel',
    name: 'orderDetailChannel',
    component: resolve => require(['@/views/order/orderDetailChannel'], resolve),
    meta: {
      title: '订单详情'
    }
  },
  {
    path: '/orderAgreementDetail',
    name: 'orderAgreementDetail',
    component: resolve => require(['@/views/order/orderAgreementDetail'], resolve),
    meta: {
      title: '订单详情'
    }
  },
  {
    path: '/logistics',
    name: 'logistics',
    component: resolve => require(['@/views/logistics/logistics'], resolve),
    meta: {
      title: '物流信息'
    }
  },
  {
    path: '/DecInstructions',
    name: 'DecInstructions',
    component: resolve => require(['@/views/doctor/decInstructions'], resolve),
    meta: {
      title: '饮片特殊煎煮说明'
    }
  },
  {
    path: '/Sitting',
    name: 'Sitting',
    component: resolve => require(['@/views/doctor/Sitting'], resolve),
    meta: {
      title: '线下坐诊信息'
    }
  },
  {
    path: '/readAccountH5',
    name: 'readAccountH5',
    component: resolve => require(['@/views/h5/readAccountH5'], resolve),
    meta: {
      title: '挂账微信账户读取'
    }
  },
  {
    path: '/hospitalIndex',
    name: 'hospitalIndex',
    component: resolve => require(['@/views/hospital/hospitalIndex.vue'], resolve),
    meta: {
      title: '找名医'
    }
  },
  {
    path: '/hospitalIndexNew',
    name: 'hospitalIndexNew',
    component: resolve => require(['@/views/hospital/index.vue'], resolve),
    meta: {
      title: '找名医'
    }
  },
  {
    path: '/doctor_search',
    name: 'doctor_search',
    component: resolve => require(['@/views/hospital/doctor_search.vue'], resolve),
    meta: {
      title: '找名医'
    }
  },
  {
    path: '/doctor_recommend',
    name: 'doctor_recommend',
    component: resolve => require(['@/views/hospital/doctor_recommend.vue'], resolve),
    meta: {
      title: '推荐医生'
    }
  },
  {
    path: '/doctorList',
    name: 'doctorList',
    component: resolve => require(['@/views/hospital/doctorList.vue'], resolve),
    meta: {
      title: '医生列表',
      keepAlive: true, // 需要缓存
      isBack: false // 用于判断上一个页面是哪个
    }
  },
  {
    path: '/outpatient',
    name: 'outpatient',
    component: resolve => require(['@/views/hospital/outpatient.vue'], resolve),
    meta: {
      title: '门诊列表'
    }
  },
  {
    path: '/antiActive',
    name: 'AntiActive',
    component: resolve => require(['@/views/antiEpidemic/antiActive.vue'], resolve),
    meta: {
      title: '抗疫物资活动'
    }
  }, {
    path: '/shareFriend',
    name: 'ShareFriend',
    component: resolve => require(['@/views/antiEpidemic/shareFriend.vue'], resolve),
    meta: {
      title: '分享朋友圈'
    }
  },
  {
    path: '/pfzy',
    name: 'pfzy',
    component: resolve => require(['@/views/pfzy/pfzy.vue'], resolve),
    meta: {
      title: '拍方抓药'
    }
  },
  {
    path: '/pfHis',
    name: 'pfHis',
    component: resolve => require(['@/views/pfzy/pfHis.vue'], resolve),
    meta: {
      title: '历史拍方记录'
    }
  },
  {
    path: '/jzr',
    name: 'jzr',
    component: resolve => require(['@/views/pfzy/jzr.vue'], resolve),
    meta: {
      title: '选择就诊人'
    }
  },
  {
    path: '/choosedoctor',
    name: 'choosedoctor',
    component: resolve => require(['@/views/pfzy/choosedoctor.vue'], resolve),
    meta: {
      title: '选择医生'
    }
  },
  {
    path: '/pfsuccess',
    name: 'pfsuccess',
    component: resolve => require(['@/views/pfzy/success.vue'], resolve),
    meta: {
      title: '提交成功'
    }
  },
  {
    path: '/pfdetail',
    name: 'pfdetail',
    component: resolve => require(['@/views/pfzy/pfdetail.vue'], resolve),
    meta: {
      title: '拍方详情'
    }
  },
  {
    path: '/invitefriend',
    name: 'inviteFriend',
    component: resolve => require(['@/views/discountCoupon/inviteFriend.vue'], resolve),
    meta: {
      title: '邀请好友赢优惠礼包'
    }
  },
  {
    path: '/discountlist',
    name: 'discountList',
    component: resolve => require(['@/views/myCenter/discounts.vue'], resolve),
    meta: {
      title: '我的优惠券'
    }
  }, {
    path: '/giftbag',
    name: 'giftBag',
    component: resolve => require(['@/views/discountCoupon/giftBag.vue'], resolve),
    meta: {
      title: '优惠券礼包'
    }
  },
  {
    path: '/yyregisterIndex',
    name: 'yyregisterIndex',
    component: resolve => require(['@/views/yyregister/index.vue'], resolve),
    meta: {
      title: '预约挂号'
    }
  },
  {
    path: '/clinic_choose',
    name: 'clinic_choose',
    component: resolve => require(['@/views/yyregister/clinic_choose.vue'], resolve),
    meta: {
      title: '选择医珍堂'
    }
  },
  {
    path: '/yyinfo',
    name: 'yyinfo',
    component: resolve => require(['@/views/yyregister/yyinfo.vue'], resolve),
    meta: {
      title: '预约挂号'
    }
  },
  {
    path: '/yydoctor',
    name: 'yydoctor',
    component: resolve => require(['@/views/yyregister/yydoctor.vue'], resolve),
    meta: {
      title: '预约挂号'
    }
  },
  {
    path: '/yylist',
    name: 'yylist',
    component: resolve => require(['@/views/yyregister/yylist.vue'], resolve),
    meta: {
      title: '门诊预约单'
    }
  }, {
    path: '/yyorder',
    name: 'yyorder',
    component: resolve => require(['@/views/yyregister/yyorder.vue'], resolve),
    meta: {
      title: '预约订单'
    }
  },
  {
    path: '/docnotice',
    name: 'docNotice',
    component: resolve => require(['@/views/hospital/docnotice.vue'], resolve),
    meta: {
      title: '医生公告'
    }
  },  {
    path: '/docnotice-setting',
    name: 'docNoticeSetting',
    component: resolve => require(['@/views/hospital/docNoticeSetting.vue'], resolve),
    meta: {
      title: '医生公告设置'
    }
  }, {
    path: '/docarticlelist',
    name: 'docArticleList',
    component: resolve => require(['@/views/hospital/docarticlelist.vue'], resolve),
    meta: {
      title: '医生文章'
    }
  }, {
    path: '/docevaluate',
    name: 'docEvaluate',
    component: resolve => require(['@/views/hospital/docevaluate.vue'], resolve),
    meta: {
      title: '全部评价'
    }
  }, {
    path: '/followlist',
    name: 'followList',
    component: resolve => require(['@/views/doctor/followlist.vue'], resolve),
    meta: {
      title: '用药反馈'
    }
  }, {
    path: '/conditioning_details',
    name: 'conditioningDetails',
    component: resolve => require(['@/views/hospital/conditioning_details.vue'], resolve),
    meta: {
      title: '调理方案'
    }
  }, {
    path: '/service',
    name: 'service',
    component: resolve => require(['@/views/myCenter/service.vue'], resolve),
    meta: {
      title: '联系客服'
    }
  }, {
    path: '/specialTest',
    name: 'specialTest',
    component: resolve => require(['@/views/im/specialTest.vue'], resolve),
    meta: {
      title: '问诊单'
    }
  },
  {
    path: '/quickInquiry',
    name: 'QuickInquiry',
    component: resolve => require(['@/views/quickInquiry/index.vue'], resolve),
    meta: {
      title: '极速问诊'
    }
  },
  {
    path: '/selectPatient',
    name: 'SelectPatient',
    component: resolve => require(['@/views/quickInquiry/selectPatient.vue'], resolve),
    meta: {
      title: '极速问诊'
    }
  },
  {
    path: '/symptom',
    name: 'Symptom',
    component: resolve => require(['@/views/quickInquiry/symptom.vue'], resolve),
    meta: {
      title: '极速问诊'
    }
  },
  {
    path: '/payment',
    name: 'Payment',
    component: resolve => require(['@/views/quickInquiry/payment.vue'], resolve),
    meta: {
      title: '支付订单'
    }
  },
  {
    path: '/inquiryCard',
    name: 'InquiryCard',
    component: resolve => require(['@/views/quickInquiry/inquiryCard.vue'], resolve),
    meta: {
      title: '极速问诊'
    }
  },
  {
    path: '/recipeDetail',
    name: 'recipeDetail',
    component: resolve => require(['@/views/order/recipeDetail.vue'], resolve),
    meta: {
      title: '电子处方笺'
    }
  },
  {
    path: '/pfzyStart',
    name: 'pfzyStart',
    component: resolve => require(['@/views/pfzy/start.vue'], resolve),
    meta: {
      title: '拍方抓药'
    }
  },
  {
    path: '/yixinStart',
    name: 'yixinStart',
    component: resolve => require(['@/views/channel/yixinStart.vue'], resolve),
    meta: {
      title: '问诊单'
    }
  },
  {
    path: '/channelIndex',
    name: 'doctorListYiXin',
    component: resolve => require(['@/views/hospital/doctorListYiXin.vue'], resolve),
    meta: {
      title: '找名医'
    }
  },

  {
    path: '/recipeUpload',
    name: 'recipeUpload',
    component: resolve => require(['@/views/doctor/recipeUpload.vue'], resolve),
    meta: {
      title: '上传处方病历'
    }
  },
  {
    path: '/my_invoice',
    name: 'myInvoice',
    component: resolve => require(['@/views/invoice/index.vue'], resolve),
    meta: {
      title: '开发票'
    }
  },
  {
    path: '/invoice_history',
    name: 'invoiceHistory',
    component: resolve => require(['@/views/invoice/invoice_history.vue'], resolve),
    meta: {
      title: '发票记录'
    }
  },
  {
    path: '/invoice_order_list',
    name: 'invoiceOrderList',
    component: resolve => require(['@/views/invoice/invoice_order_list.vue'], resolve),
    meta: {
      title: '开发票'
    }
  },
  {
    path: '/invoice_info',
    name: 'invoiceInfo',
    component: resolve => require(['@/views/invoice/invoice_info.vue'], resolve),
    meta: {
      title: '填写发票信息',
      keepAlive: true
    }
  },
  {
    path: '/invoice_optional_info',
    name: 'invoiceOptionalInfo',
    component: resolve => require(['@/views/invoice/invoice_optional_info.vue'], resolve),
    meta: {
      title: '填写发票信息'
    }
  },
  {
    path: '/invoice_detail',
    name: 'InvoiceDetail',
    component: resolve => require(['@/views/invoice/invoice_detail.vue'], resolve),
    meta: {
      title: '发票详情'
    }
  },
  {
    path: '/invoice_order_detail',
    name: 'InvoiceOrderDetail',
    component: resolve => require(['@/views/invoice/invoice_order_detail.vue'], resolve),
    meta: {
      title: '发票订单详情'
    }
  },
  {
    path: '/invoice_success',
    name: 'invoiceSuccess',
    component: resolve => require(['@/views/invoice/success.vue'], resolve),
    meta: {
      title: '提交成功'
    }
  },
  {
    path: '/invoice_title_manager',
    name: 'invoiceTitleManager',
    component: resolve => require(['@/views/invoice/titleManager/index.vue'], resolve),
    meta: {
      title: '抬头管理'
    }
  },
  {
    path: '/invoice_title_add',
    name: 'invoiceTitleAdd',
    component: resolve => require(['@/views/invoice/titleManager/add.vue'], resolve),
    meta: {
      title: '抬头管理'
    }
  },
  {
    path: '/invoice_title_edit',
    name: 'invoiceTitleEdit',
    component: resolve => require(['@/views/invoice/titleManager/edit.vue'], resolve),
    meta: {
      title: '抬头管理'
    }
  },
  {
    path: '/invoice_pdf_viewer',
    name: 'InvoicePdfViewer',
    component: resolve => require(['@/views/invoice/invoice_pdf_viewer.vue'], resolve),
    meta: {
      title: '电子发票'
    }
  },
  {
    path: '/order_detail_invoice',
    name: 'OrderDetailInvoice',
    component: resolve => require(['@/views/invoice/order_detail_invoice.vue'], resolve),
    meta: {
      title: '开发票'
    }
  },
  {
    path: '/openScreen',
    name: 'OpenScreen',
    component: resolve => require(['@/views/hospital/openScreen.vue'], resolve),
    meta: {
      title: '上医明家'
    }
  },
  // 拍方抓药新版本路由地址
  {
    path: '/newpfzyStart',
    name: 'newpfzyStart',
    component: resolve => require(['@/views/newpfzy/start.vue'], resolve),
    meta: {
      title: '拍方抓药'
    }
  },
  {
    path: '/newpfzy',
    name: 'newpfzy',
    component: resolve => require(['@/views/newpfzy/pfzy.vue'], resolve),
    meta: {
      title: '拍方抓药'
    }
  },
  {
    path: '/newpfHis',
    name: 'newpfHis',
    component: resolve => require(['@/views/newpfzy/pfHis.vue'], resolve),
    meta: {
      title: '历史拍方记录'
    }
  },
  {
    path: '/newjzr',
    name: 'newjzr',
    component: resolve => require(['@/views/newpfzy/jzr.vue'], resolve),
    meta: {
      title: '选择就诊人'
    }
  },
  {
    path: '/newchoosedoctor',
    name: 'newchoosedoctor',
    component: resolve => require(['@/views/newpfzy/choosedoctor.vue'], resolve),
    meta: {
      title: '选择医生'
    }
  },
  {
    path: '/newpfsuccess',
    name: 'newpfsuccess',
    component: resolve => require(['@/views/newpfzy/success.vue'], resolve),
    meta: {
      title: '提交成功'
    }
  },
  {
    path: '/newpfdetail',
    name: 'newpfdetail',
    component: resolve => require(['@/views/newpfzy/pfdetail.vue'], resolve),
    meta: {
      title: '拍方详情'
    } ,
  },
  {
    path: '/inquiriesStart',
    name: 'inquiriesStart',
    component: resolve => require(['@/views/h5/inquiriesStart.vue'], resolve),
    meta: {
      title: '问诊单'
    }
  },
  {
    path: '/yzDoctorList',
    name: 'yzDoctorList',
    component: resolve => require(['@/views/hospital/yzDoctorList.vue'], resolve),
    meta: {
      title: '义诊专家'
    }
  },{
    path: '/nCovActive',
    name: 'nCovActive',
    component: resolve => require(['@/views/activity/nCovActive.vue'], resolve),
    meta: {
      title: ''
    }
  },{
    path: '/nCovDrugDetail',
    name: 'nCovDrugDetail',
    component: resolve => require(['@/views/activity/nCovDrugDetail.vue'], resolve),
    meta: {
      title: ''
    }
  },
  {
    path: '/peopleSupplement',
    name: 'peopleSupplement',
    component: resolve => require(['@/views/people/people_info_supplement'], resolve),
    meta: {
      title: '基础信息'
    }
  },{
    path: '/chaosiLogin',
    name: 'chaosiLogin',
    component: resolve => require(['@/views/chaosi/login.vue'], resolve),
    meta: {
      title: '登录'
    }
  },{
    path: '/chaosiReportList',
    name: 'chaosiReportList',
    component: resolve => require(['@/views/chaosi/reportList.vue'], resolve),
    meta: {
      title: '检测报告'
    }
  },{
    path: '/chaosiReport',
    name: 'chaosiReport',
    component: resolve => require(['@/views/chaosi/report.vue'], resolve),
    meta: {
      title: '检测报告'
    }
  },
  ]
})

/* -------------------------------------------------------------------------------- */
// AppId = 'wx00a647491b70a8fa' // 正式
// AppId = 'wx57770658f0e3acb8' // 预发1
// AppId = 'wxb2f8d5a6845a53ae' // 预发2
// AppId = 'wx925126e9c295af99' // 测试1
// AppId = 'wx7d283f7813d3ebcb' // 测试2
/* -------------------------------------------------------------------------------- */

// 获取url参数
function getQueryVariable (variable) {
  var query = window.location.search.substring(1)
  var vars = query.split('&')
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split('=')
    if (pair[0] == variable) {
      return pair[1]
    }
  }
  return null
}

// 指定不需要拦截的查看权限ID
const roleWhiteList = ['o92LXv1ZIHTjleF3MYPFlAiV7Bas','o92LXv2u1lVPwpyAQaa08fxdIU0g'];

// 页面进入前执行判断(关注、客服电话、渠道)
function checkRouter (to, callback) {
  Vue.prototype.$post('/member/queryUserType.action', {
    openId: global.memberId,
    userCode: global.userCode
  }).then(res => {
    if (res.respCode == 1001 && res.data) {
      // 判断用户身份和当前所进入的环境一致
      if ((res.data.userType == 1 && global.base == '/syrjiaPatientEnd') || (res.data.userType == 2 && global.base == '/syrjiaPatientEndbetatest')) {
        if (to.meta.title) {
          document.title = to.meta.title
        }
        // 1109 袋拉拉渠道数据统计埋点
        if (to.query.moduleSign == 'moduleSign') {
          if (to.name == 'centerIndex' || to.name == 'pfzy' || to.name == 'referral') {
            Vue.prototype.$post('/banner/addClickRecord.action', {
              moduleSign: window.location.protocol + '//' + window.location.host + '/syrjiaPatientEnd' + to.path + '?moduleSign=moduleSign'
            })
          } else if (to.name == 'hospitalIndex') {
            Vue.prototype.$post('/banner/addClickRecord.action', {
              moduleSign: window.location.protocol + '//' + window.location.host + '/syrjiaPatientEnd' + to.path + '?moduleSign=moduleSign'
            }).then(res => {
              window.location.replace(window.location.protocol + '//' + window.location.host + '/syrjiaPatientEnd' + to.path)
            })
          } else if (to.name == 'epidemicActivity') {
            Vue.prototype.$post('/banner/addClickRecord.action', {
              moduleSign: window.location.protocol + '//' + window.location.host + '/syrjiaPatientEnd/epidemicActivity?moduleSign=moduleSign'
            }).then(res => {
              window.location.replace(window.location.protocol + '//' + window.location.host + '/syrjiaPatientEnd/epidemicActivity?id=' + to.query.id)
            })
          }else if (to.name == 'offineStatistics') {
            if (roleWhiteList.includes(global.memberId)) {
              Vue.prototype.$post('/banner/addClickRecord.action', {
                moduleSign: window.location.protocol + '//' + window.location.host + '/syrjiaPatientEnd/offineStatistics?moduleSign=moduleSign'
              }).then(res => {
                window.location.replace(window.location.protocol + '//' + window.location.host + '/syrjiaPatientEnd/offineStatistics?id=' + to.query.id)
              })
            }else{
                Vue.prototype.$utils.openAlert2('账号无访问权限！')
                // 账号无访问权限
                return false
            }
          }
        }



        // 调用是否关注
        if (!global.isAttention && (!global.channelSign || global.channelSign == 'syrjia')) {
          Vue.prototype.$post('/member/getMember.action', {
            openId: global.memberId
          }).then(response => {
            if (response.respCode != 1001) {
              // 排除订单详情 和地址 未关注可以支付订单 排除防疫活动
              if (to.name != 'buyService' &&to.name != 'orderDetail' && to.name != 'modifyAddress' && to.name != 'chooseAddress' && to.name != 'addAddress' && ['agreement', 'epidemicActivity', 'epidemicNewsDetail', 'im_prescription'].indexOf(to.name) === -1 && to.name != 'nCovActive') {
                Vue.prototype.$attentionPop.open() // 没有关注 打开关注弹窗
              }
            } else {
              if (response.data.state == 2) {
                Vue.prototype.$utils.openAlert2('账号异常,请联系客服处理')
                // 账号异常 联系客服处理
                return false
              }
              global.isAttention = true // 存储关注状态
              window.sessionStorage.isAttention = true // 存储关注状态
            }
          })
        }
        if (!window.sessionStorage.serverPhone) { // 上医获取客服电话
          if (global.channelSign && global.channelSign == 'syrjia') {
            Vue.prototype.$post('/querySysSet.action', {}).then((response) => {
              if (response && response.respCode == 1001) {
                window.sessionStorage.serverPhone = response.data.serverPhone || ''
              }
            })
          } else {
            Vue.prototype.$post('/patientReport/queryChannelColumnSet.action', {
              memberId: global.memberId,
              channelSign: global.channelSign
            }).then(res => {
              if (res.respCode == 1001) {
                window.sessionStorage.serverPhone = res.data.serverPhone || ''
              }
            })
          }
        }
        // 如果是渠道 就调用下面方法
        if (global.channelSign && global.channelSign != 'syrjia' && process.env.NODE_ENV != 'development') {
          global.isAttention = true // 存储关注状态
          window.sessionStorage.isAttention = true // 存储关注状态
          Vue.prototype.$post('/member/checkChannelSign.action', {
            memberId: global.memberId,
            channelSign: global.channelSign
          }).then(response => {
            if (response.respCode != 1001) {
              Vue.prototype.$utils.openAlert2(response.respMsg)
              // 账号异常 联系客服处理
              return false
            } else {
              callback()
            }
          })
        } else {
          callback()
        }
      } else {
        let url = ''
        if (res.data.userType == 1) {
          url = window.location.protocol + '//' + window.location.host + '/syrjiaPatientEnd' + to.path
        } else {
          url = window.location.protocol + '//' + window.location.host + '/syrjiaPatientEndbetatest' + to.path
        }
        window.location.replace(url)
      }
    } else {
      Vue.prototype.$utils.openAlert2(res.respMsg)
    }
  })
}

// 协议：检查是否首次访问公众号
const checkIsFirstAccessPage = async () => {
  const isFirstAccess = await store.dispatch('agreement/getReadAgreements')
  return isFirstAccess
}

// 协议：控制显示协议页面
const checkFirstAccessShowAgreePage = async (to, next) => {
  const agreeWithList = ['OpenScreen', 'agreement']
  // 协议相关 是否是首次访问
  if (agreeWithList.indexOf(to.name) === -1) {
    // 前端标记 是否已同意协议
    const tokenAccess = sessionStorage.getItem('FirstAccessWx')
    // 微信授权过
    const authToken = global.memberId
    if (!authToken || ['null', 'undefined'].indexOf(authToken) > -1 || !global.unionidState) {
      return false
    }
    if (tokenAccess !== '0') {
      const isFirstAccess = await checkIsFirstAccessPage()
      //  首次访问
      if (isFirstAccess) {
        next({
          name: 'OpenScreen',
          query: {
            redirect: to.fullPath
          }
        })
        return true
      }
    }
  }
}
// 指定不需要拦截的路由路径数组
const whiteList = ['/offineStatistics','/people_info_channel','/people_info_channel2','/orderDetailChannel','/chooseAddressChannel','/addAddressChannel','/modifyAddressChannel','/pay_h5'];

// 全局路由守卫
router.beforeEach(async (to, from, next) => {


  // 暂存渠道码id
  if (to.query.channelInsideId) {
    sessionStorage.setItem('channelInsideId', to.query.channelInsideId)
  }

  if (to.query.channelSign) {
    // 如果链接上带的渠道标签是皮科 强制变成syrjia
    let channelSign = to.query.channelSign
    if(channelSign == 'dermatology') channelSign = 'syrjia'
    sessionStorage.setItem('channelSign', channelSign)
    global.channelSign = sessionStorage.getItem('channelSign')
  }
  const channelSignParam = getQueryVariable('channelSign') || global.channelSign
  // 获取本地缓存channelSign
  const channelSign = localStorage.getItem('syrjia_channelSign')
  // 地缓存channelSign 和 当前channelSignParam比较
  const isNotSameSign = channelSignParam !== channelSign
  // console.log(to.query.onlyVideo,'.........................')
  if (to.query.onlyVideo && to.query.onlyVideo == 1) {
    sessionStorage.setItem('onlyVideo', to.query.onlyVideo)
    global.onlyVideo = sessionStorage.getItem('onlyVideo')
  }
 const queryId = getQueryVariable('doctorId')||getQueryVariable('channelParam')
 if(queryId!=null&&queryId!=''&&queryId!=undefined){
    sessionStorage.setItem('userCode', queryId.split("@")[1])
  }else{
    sessionStorage.setItem('userCode', '')
  }

  // 第一次进入公众号时 如果渠道不一样
  if (isNotSameSign) { // 清空缓存的openId 目地重新获取openId
    localStorage.removeItem('openId')
    global.memberId = ''
    global.use = ''
    global.userCode = ''
    window.sessionStorage.serverPhone = ''
    sessionStorage.removeItem('FirstAccessWx')
  }


  // 判断目标路由是否在白名单内
  if (to.name == 'pay_hint' || to.name === 'invoiceSuccess' || to.name === 'paySuccess' || to.name === 'diseaseManageDetail') {
      console.log(to.name, "router click next")
      next()
      return false
  }

      // 协议相关 是否是首次访问
      const result = await checkFirstAccessShowAgreePage(to, next)
      if (result&&!whiteList.includes(to.path)) {
        return
      }

      if (isNotSameSign || (global.memberId == null || global.memberId == 'null' || global.memberId == '' || global.memberId == undefined || global.memberId == 'undefined' || !global.unionidState)) {
        var code = getQueryVariable('code')
        let local = window.location.href
        localStorage.setItem('syrjia_channelSign', global.channelSign)
        // (当前渠道和缓存渠道不同 || 无微信code)   重新通过appid进行授权 得到微信code 再换取openId
        if (isNotSameSign || code == null || code === '') {
          // 清除当前url上的code state微信参数 用来避免微信重定向url上code state参数重复
          let redirectUri = ''
          if(to.query.channelSign == 'dermatology') { //如果链接上是皮科 把渠道以前清除
            redirectUri = local.replace(/&code=[^&]*/g, '').replace(/&state=[^&]*/g, '').replace(/&channelSign=[^&]*/g, '')
          } else{
            redirectUri = local.replace(/&code=[^&]*/g, '').replace(/&state=[^&]*/g, '')
          }
          let AppId = ''
          Vue.prototype.axios({
            method: 'POST',
            url: global.href + '/syrjiaPtApi/member/queryWeixinAccount.action', // 接口迁移后接口路径修改备注
            data: 'channelSign=' + global.channelSign
          }).then((res) => {
            if (res.data.respCode == 1001 && res.data.data) {
              AppId = res.data.data.wxAppId
              let url = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + AppId + '&redirect_uri=' + encodeURIComponent(redirectUri) + '&response_type=code&scope=snsapi_userinfo&state=1#wechat_redirect'
              if (whiteList.includes(to.path)) {
                url = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + AppId + '&redirect_uri=' + encodeURIComponent(redirectUri) + '&response_type=code&scope=snsapi_base&state=1#wechat_redirect'
              }
              window.location.replace(url)
            }
          }).catch(err => {
            console.log('err', err)
          })
        } else { // 存在code根据code换取openId
          Vue.prototype.axios({
            method: 'POST',
            url: global.href + '/syrjiaPtApi/member/queryOpenIdByCode.action', // 接口迁移后接口路径修改备注
            data: 'code=' + code + '&channelSign=' + global.channelSign + '&userCode=' + sessionStorage.getItem('userCode')
          }).then(async function(res) {
            if (res.data.respCode == 1001) {
              if (res.data.data && res.data.data != null && res.data.data != '') {
                localStorage.setItem('openId', res.data.data.result)
                global.memberId = localStorage.getItem('openId')
                localStorage.setItem('unionidState', '1.0.0')
                global.unionidState = localStorage.getItem('unionidState')
                // 协议相关 是否是首次访问
                const result = await checkFirstAccessShowAgreePage(to, next)
                if (result) return
              }
              checkRouter(to, next)
            } else {
              Vue.prototype.$utils.openAlert2(res.data.respMsg)
              // 账号异常 联系客服处理
              return false
            }
          }).catch(function (err) {
            console.log(err)
          })
        }
      } else {
        checkRouter(to, next)
      }
})
router.afterEach((to, from) => {
  Vue.nextTick(() => {
    // sensors.quick('autoTrackSinglePage')
  })
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js